module.exports = __webpack_public_path__ + "media/images/smart_phone/delivery_status_notifications/ico_derivery01_2-ec9dc27dbc05309d50563f425c822aeb.png";